/**
 * It takes searchParams.toString() and returns an object. It supports tuples with a same key.
 */
export const getSearchParamsObject = (searchParamsString: string): { [key: string]: string | string[] } => {
  const object: { [key: string]: string | string[] } = {}

  const pairs = searchParamsString.split('&')

  pairs.forEach((pair) => {
    const [key, value] = pair.split('=')

    const decodedKey = decodeURIComponent(key)
    const decodedValue = decodeURIComponent(value)

    if (decodedKey.includes('[]')) {
      if (object[decodedKey]) {
        object[decodedKey] = [...object[decodedKey], ...decodedValue.split(',')]
      } else {
        object[decodedKey] = [...decodedValue.split(',')]
      }
    } else {
      object[decodedKey] = decodedValue
    }
  })

  return object
}
